<template>
	<div
		:class="{ 'with-answer': highlightAnswer }"
		class="select-rock-paper-scissors">
		<div
			v-for="(opt, idx) in selections"
			:key="idx"
			:class="opt.classes"
			class="select-rock-paper-scissors__option"
			@click="selected(opt)">
			<div class="img-container">
				<img
					:src="opt.img"
					:alt="opt.text" />
			</div>

			<div class="heading-6">{{ opt.text }}</div>
		</div>
	</div>
</template>

<script>
	import Options from '@/reference';

	export default {
		name: 'select-rock-paper-scissors',
		props: {
			highlightAnswer: { type: Boolean, default: false },
			selectedAnswer: { type: Object },
		},
		computed: {
			selections() {
				return Options.map((opt) => {
					let classes = opt.color;

					if (this.highlightAnswer) {
						if (this.selectedAnswer?.id === opt.id) {
							classes += ' selected';
						} else if (this.selectedAnswer?.id) {
							classes += ' not-selected';
						}
					}

					return {
						...opt,
						classes,
					};
				});
			},
		},
		methods: {
			selected(opt) {
				this.$emit('selected', opt);
			},
		},
	};
</script>

<style lang="scss">
	.select-rock-paper-scissors {
		@extend %flex-row-wrap, %justify-content-center;
		gap: 36px;

		@include responsive(medium) {
			gap: 22px;
		}

		@include responsive($mobile-size) {
			gap: 12px;
		}

		&.with-answer {
			gap: 24px;
		}

		&__option {
			@extend %layout-flex-center-y;
			gap: 8px;
			padding: 12px 16px;
			background-color: color('white');
			border-radius: 8px;
			border: 4px solid;
			box-shadow: 0px 4px 8px rgba(color('black'), 0.15);
			cursor: pointer;
			transition: all 0.4s ease;

			@include responsive(medium) {
				width: 111px;
				gap: 4px;
				padding: 6px 8px;
			}

			@include responsive($mobile-size) {
				width: 92px;
				height: 92px;
			}

			&:hover,
			&.selected {
				transform: scale(1.05);
			}

			&:hover {
				box-shadow: 0px 8px 4.6px rgba(color('black'), 0.25);
			}

			&.sunset-coral {
				border-color: color('sunset-coral');
				background: linear-gradient(rgba(color('sunset-coral'), 0.4), rgba(color('sunset-coral'), 0.4)), color('white');
			}

			&.teal-tide {
				border-color: color('teal-tide');
				background: linear-gradient(rgba(color('teal-tide'), 0.4), rgba(color('teal-tide'), 0.4)), color('white');
			}

			&.bahay-kubo {
				border-color: color('bahay-kubo');
				background: linear-gradient(rgba(color('bahay-kubo'), 0.4), rgba(color('bahay-kubo'), 0.4)), color('white');
			}

			&.selected {
				box-shadow: 0px 4px 4.6px rgba(color('black'), 0.25);
			}

			&.not-selected {
				transform: scale(0.9);
				box-shadow: 0px 4px 4px rgba(color('black'), 0.15);
				opacity: 50%;
			}

			.img-container {
				@extend %layout-flex-center-xy;
				height: 102px;

				@include responsive($mobile-size) {
					height: 72px;
				}

				img {
					height: 100%;
					display: block;

					@include responsive(medium) {
						height: 80%;
					}
				}
			}

			.heading-6 {
				font-weight: var(--font-weight-black);

				@include responsive($mobile-size) {
					display: none;
				}
			}
		}
	}
</style>
